module.exports = __webpack_public_path__ + "img/logo-main.b857bd9f.svg";